import { render, staticRenderFns } from "./AnswerCard.vue?vue&type=template&id=0c40adc0"
import script from "./AnswerCard.vue?vue&type=script&lang=js"
export * from "./AnswerCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports